import React from "react";
import {
  getLocationAddressLine,
  getLocationSuite,
} from "schemas/address";

export const TablePatient = ({
  dataRequest,
  targetRequest,
  dateService,
  className,
}) => {
  const addressLine = getLocationAddressLine(dataRequest.location);
  const suite = getLocationSuite(dataRequest.location);
  const { first_name, last_name, date_of_birth } = targetRequest;
  return (
    <div className={className}>
      <table style={{ width: "100%" }}>
        <tr>
          <td>Patient Name</td>
          <td>{`${first_name} ${last_name}`}</td>
        </tr>
        <tr>
          <td>Date of Birth</td>
          <td>{date_of_birth}</td>
        </tr>
        <tr>
          <td>Address</td>
          <td>{`${addressLine}${suite ? `, Suite ${suite}` : ""}`}</td>
        </tr>
        <tr>
          <td>Date of Service</td>
          <td>{dateService}</td>
        </tr>
      </table>
    </div>
  );
};
